// extracted by mini-css-extract-plugin
module.exports = {"containing":"useradmin_containing__1kK43","buttonAdd":"useradmin_buttonAdd__3YPWD","buttonTrash":"useradmin_buttonTrash__7gmWi"};